<div class="container" [class.active]="notification.status === NotificationStatus.UNREAD"
     (click)="notificationClicked($event)">
  <div class="logo">
    <app-notifications-biller-logo
      *ngIf="notification.iconType === IconType.BILLER; else otherIcon"
      [billerCodes]="notification.biller"
    ></app-notifications-biller-logo>

    <ng-template #otherIcon>
      <app-notifications-icon [iconType]="notification.iconType"></app-notifications-icon>
    </ng-template>
  </div>
  <div class="border">
    <div class="content">
      <div class="title">{{ notification.title }}</div>
      <div class="body">{{ notification.content }}</div>
      <button
        *ngIf="notification.cta"
        class="custom-notification-button"
        [class.read]="notification.status === NotificationStatus.READ"
      >{{ notification.cta }}
      </button>
    </div>
    <div class="suffix">
      <div class="date">{{ notification.createdAt | date: 'd MMM':'':'pl' }}</div>
      <div class="menu" id="actions-menu">
        <app-notifications-actions-menu
          [notification]="notification"
          (handleClose)="handleClose.emit()"
        ></app-notifications-actions-menu>
      </div>
    </div>
  </div>
</div>
